module.exports = require('./helpers/bundle-url').getBundleURL('15Vj6') + "btn_twitter.c03ab3f4.png";